import { paymentPlanModel } from "@/feature-wallet/models/payment-plans.mjs";
import { userSubscriptionModel } from "@/feature-wallet/models/user-subscriptions.mjs";
import gql from "@/util/graphql-query.mjs";

export const proPricing = gql`
  query GetProPricing($paymentMethodId: String, $providerType: PaymentProviderType!, $includeUserInfo: Boolean!) {
    paymentPlan(paymentMethodId: $paymentMethodId, providerType: $providerType) { ${paymentPlanModel} }
    isEligibleForFreeTrial @include(if: $includeUserInfo)
  }
`;

export const subscribeToPro = gql`
  mutation CreateProSubscription($isTrial: Boolean, $plan: SubscriptionPaymentPlanType!, $providerType: PaymentProviderType!, $paymentMethodId: ID, $couponCode: String) {
    subscribeToPlan(isTrial: $isTrial, plan: $plan, providerType: $providerType, paymentMethodId: $paymentMethodId, couponCode: $couponCode) {
      ${userSubscriptionModel}
    }
}`;
